import { createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';

import { ManageBookingFeatureState, ManageBookingState, StatusState } from '../../interfaces/store.interface';
import { MmbError, MmbStage } from '../../enums';
import { selectManageBookingState } from './feature.selector';

const _selectStatusState = createSelector(selectManageBookingState, (state: ManageBookingState) => state.state);

const _getLoading = createSelector(_selectStatusState, (state: StatusState) => state.loading);
const _getError = createSelector(_selectStatusState, (state: StatusState) => state.error);
const _getStage = createSelector(_selectStatusState, (state: StatusState) => state.stage);
const _isServicesDirty = createSelector(_selectStatusState, (state: StatusState) => state.servicesDirty);

export const getLoading = (): StateSelector<ManageBookingFeatureState, boolean> => select(_getLoading);
export const getError = (): StateSelector<ManageBookingFeatureState, MmbError> => select(_getError);
export const getStage = (): StateSelector<ManageBookingFeatureState, MmbStage> => select(_getStage);
export const isServicesDirty = (): StateSelector<ManageBookingFeatureState, boolean> => select(_isServicesDirty);
